// usePageReset — микро-хук канона «фильтр изменён → страница 0» (§6.2 №3).
// Причина: канон был размазан по 4 хендлерам DealsListPage и был забыт в
// TasksListPage (баг FE-2 REVIEW-20260907: смена фильтра без сброса пагинации
// даёт запрос пустой страницы → ложный EmptyState).

import { useCallback } from 'react';

/**
 * Возвращает обёртку фильтр-хендлера: сначала сброс пагинации в 0, затем
 * применение фильтра. Аргументы хендлера передаются как есть.
 *
 * @param setPage сеттер номера страницы списка
 * @returns функция `withPageReset(applyFilter)` — обёрнутый хендлер
 */
export function usePageReset(setPage: (page: number) => void): <Args extends unknown[]>(
  applyFilter: (...args: Args) => void,
) => (...args: Args) => void {
  return useCallback(
    <Args extends unknown[]>(applyFilter: (...args: Args) => void) =>
      (...args: Args): void => {
        setPage(0);
        applyFilter(...args);
      },
    [setPage],
  );
}
